import { useContext } from 'react';
import AssetContext from '../common/AssetContext';
export default function() {
    return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    useContext(AssetContext));
};
